import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedSTOperationSharedUid: "", // selected site shared_uid
  selectedSTOperationAccount: "", // selected accout shared_uid
  accountsForSTOperation: [], // All accounts data
  scopesOfSTOperation: [], // Scopes data
  campaignsWithoutScopeData: [], // Campaigns Without Scopes
  negativesInListAndInAdGroupData: [], //2nd table data
  negativesInTheCampaignData: [], // 3rd table data
  isScopesLoading: false,
  isScopesTabDataFetched: false, //checking is Data is fetched or not
  sortForScopesData: {
    keytoSort: "modified",
    direction: "desc",
  }, // Sorting for Scopes
  sortCampaignsWithoutScopeData: {
    keytoSort: "modified",
    direction: "desc",
  }, // sorting for Campaigns Without Scopes
  selectedNegativeSearchTerm: "", // filter serach term (2nd table)
  selectedCampaigns: [], // selected campaigns (2nd table)
  selectedAdgroups: [], // selected adgroups (2nd table)
  selectedRowsForNegatives: [], // selected rows in 2nd table
  openBulkActionModal: false, // open bulk action modal(2nd table)
  singleRowIDPassToModal: "", // when single row is selected pass row id (2nd table)

  selectedNegativeSearchTermForCampaign: "", // filter search term (3rd table)
  selectedCampaignsForCampaign: [], // selected campaigns (3rd table)
  selectedAdgroupsForCampaign: [], // selected adgroups (3rd table)
  selectedRowsForNegativesCampaign: [], // selected rows in 3rd table
  openBulkActionModalForCampaign: false, // open bulk action modal (3rd table)
  singleRowIDPassToModalForCampaign: "", // when single row is selected pass row id (3rd table)
  openMoveAnotherCampaignModal: false, // open move another campaign modal (3rd table)
  newScopeLoading: false, // loading state for creating new scope
  removeNegativeLoadingForBothLoading: false, // loading state for removing search term(2nd table)
  removeNegativeLoadingCampaignLoading: false, // loading state for removing search term(3rd table)
  campaignToScopeLoading: false, // loading state for moving campaign to scope linking from 1st table(Campaign without scope)
  selectedSingleScopeID: "", // when edit the single scope, pass the scope id
  editScopeLoading: false, // loading state for edit scope

  page2: 0, // page for 2nd table(scopes tab)
  rowsPerPage2: 10, // rows per page for 2nd table(scopes tab)
  sort2: {
    keytoSort: "search_term",
    direction: "desc",
  }, // page for 2nd table(scopes tab)

  page3: 0, // page for 3rd table(scopes tab)
  rowsPerPage3: 10, // rows per page for 3rd table(scopes tab)
  sort3: {
    keytoSort: "search_term",
    direction: "desc",
  }, // page for 3rd table(scopes tab)
};

const searchTermOperationSlice = createSlice({
  name: "searchTermOperation",
  initialState,
  reducers: {
    setSelectedSTOperationSharedUid: (state, action) => {
      state.selectedSTOperationSharedUid = action.payload;
    },
    setSelectedSTOperationAccount: (state, action) => {
      state.selectedSTOperationAccount = action.payload;
    },
    setAccountsForSTOperation: (state, action) => {
      state.accountsForSTOperation = action.payload;
    },
    setScopesOfSTOperation: (state, action) => {
      state.scopesOfSTOperation = action.payload;
    },
    setCampaignsWithoutScopeData: (state, action) => {
      state.campaignsWithoutScopeData = action.payload;
    },
    setNegativesInListAndInAdGroupData: (state, action) => {
      state.negativesInListAndInAdGroupData = action.payload;
    },
    setNegativesInTheCampaignData: (state, action) => {
      state.negativesInTheCampaignData = action.payload;
    },
    setIsScopesLoading: (state, action) => {
      state.isScopesLoading = action.payload;
    },
    setIsScopesTabDataFetched: (state, action) => {
      state.isScopesTabDataFetched = action.payload;
    },
    setSortForScopesData: (state, action) => {
      state.sortForScopesData = action.payload;
    },
    setSortCampaignsWithoutScopeData: (state, action) => {
      state.sortCampaignsWithoutScopeData = action.payload;
    },
    setSelectedNegativeSearchTerm: (state, action) => {
      state.selectedNegativeSearchTerm = action.payload;
    },
    setSelectedCampaigns: (state, action) => {
      state.selectedCampaigns = action.payload;
    },
    setSelectedAdgroups: (state, action) => {
      state.selectedAdgroups = action.payload;
    },
    setSelectedRowsForNegatives: (state, action) => {
      state.selectedRowsForNegatives = action.payload;
    },
    setOpenBulkActionModal: (state, action) => {
      state.openBulkActionModal = action.payload;
    },
    setSingleRowIDPassToModal: (state, action) => {
      state.singleRowIDPassToModal = action.payload;
    },
    setSelectedNegativeSearchTermForCampaign: (state, action) => {
      state.selectedNegativeSearchTermForCampaign = action.payload;
    },
    setSelectedCampaignsForCampaign: (state, action) => {
      state.selectedCampaignsForCampaign = action.payload;
    },
    setSelectedAdgroupsForCampaign: (state, action) => {
      state.selectedAdgroupsForCampaign = action.payload;
    },
    setSelectedRowsForNegativesCampaign: (state, action) => {
      state.selectedRowsForNegativesCampaign = action.payload;
    },
    setOpenBulkActionModalForCampaign: (state, action) => {
      state.openBulkActionModalForCampaign = action.payload;
    },
    setSingleRowIDPassToModalForCampaign: (state, action) => {
      state.singleRowIDPassToModalForCampaign = action.payload;
    },
    setOpenMoveAnotherCampaignModal: (state, action) => {
      state.openMoveAnotherCampaignModal = action.payload;
    },
    setNewScopeLoading: (state, action) => {
      state.newScopeLoading = action.payload;
    },
    setRemoveNegativeLoadingForBothLoading: (state, action) => {
      state.removeNegativeLoadingForBothLoading = action.payload;
    },
    setRemoveNegativeLoadingCampaignLoading: (state, action) => {
      state.removeNegativeLoadingCampaignLoading = action.payload;
    },
    setCampaignToScopeLoading: (state, action) => {
      state.campaignToScopeLoading = action.payload;
    },
    setSelectedSingleScopeID: (state, action) => {
      state.selectedSingleScopeID = action.payload;
    },
    setEditScopeLoading: (state, action) => {
      state.editScopeLoading = action.payload;
    },
    setPage2: (state, action) => {
      state.page2 = action.payload;
    },
    setRowsPerPage2: (state, action) => {
      state.rowsPerPage2 = action.payload;
    },
    setSort2: (state, action) => {
      state.sort2 = action.payload;
    },
    setPage3: (state, action) => {
      state.page3 = action.payload;
    },
    setRowsPerPage3: (state, action) => {
      state.rowsPerPage3 = action.payload;
    },
    setSort3: (state, action) => {
      state.sort3 = action.payload;
    },
    resetStateOfSTO: () => initialState, // reset everything
  },
});

export const {
  setSelectedSTOperationSharedUid,
  setSelectedSTOperationAccount,
  setAccountsForSTOperation,
  setScopesOfSTOperation,
  setCampaignsWithoutScopeData,
  setNegativesInListAndInAdGroupData,
  setNegativesInTheCampaignData,
  setIsScopesLoading,
  setIsScopesTabDataFetched,
  setSortForScopesData,
  setSortCampaignsWithoutScopeData,
  setSelectedNegativeSearchTerm,
  setSelectedCampaigns,
  setSelectedAdgroups,
  setSelectedRowsForNegatives,
  setOpenBulkActionModal,
  setSingleRowIDPassToModal,
  setSelectedNegativeSearchTermForCampaign,
  setSelectedCampaignsForCampaign,
  setSelectedAdgroupsForCampaign,
  setSelectedRowsForNegativesCampaign,
  setOpenBulkActionModalForCampaign,
  setSingleRowIDPassToModalForCampaign,
  setOpenMoveAnotherCampaignModal,
  setNewScopeLoading,
  setRemoveNegativeLoadingForBothLoading,
  setRemoveNegativeLoadingCampaignLoading,
  setCampaignToScopeLoading,
  setSelectedSingleScopeID,
  setEditScopeLoading,
  setPage2,
  setRowsPerPage2,
  setSort2,
  setPage3,
  setRowsPerPage3,
  setSort3,
  resetStateOfSTO,
  
} = searchTermOperationSlice.actions;

export default searchTermOperationSlice.reducer;
